import { ReactNode } from 'react';
import { TestingIcon } from '../components/common/create-icon/CreateIcon';

const customIcons: Record<string, ReactNode> = {
  TestingIcon: <TestingIcon width={'17px'} height={'17px'} />,
};

export default customIcons;
